import { useState } from "react";
import "./Book.css";

/*
 * Google Calendar appointment schedule booking pages for contact@marcthecs.com.
 * To change availability, duration or buffers, edit the appointment schedule in
 * Google Calendar itself -- these links stay the same.
 */
const BOOKING_LINKS = {
    30: "https://calendar.app.google/EewViRfBXHxr7Z4H8",
    60: "https://calendar.app.google/KVzFQhjVa8hnySS6A",
};

const VENMO_HANDLE = "MarcAMartin";
const EMAIL = "contact@marcthecs.com";

const SESSIONS = [
    {
        minutes: 30,
        price: 50,
        tagline: "AI Foundation and Intro",
        blurb: "A guided intro to AI: how it works, what to install, and where to start.",
    },
    {
        minutes: 60,
        price: 90,
        tagline: "Set up + build",
        blurb: "Full environment setup and we build something real together, start to finish.",
    },
];

function venmoLink(minutes, price) {
    const note = `1:1 AI session (${minutes} min)`;
    return `https://venmo.com/?txn=pay&recipients=${VENMO_HANDLE}&amount=${price}&note=${encodeURIComponent(note)}`;
}

function bookingHref(minutes) {
    const link = BOOKING_LINKS[minutes];
    if (link) return link;
    const subject = `1:1 AI Foundations - ${minutes} min session`;
    const body =
        `Hi Marc,\n\nI'd like to book the ${minutes} minute 1:1 AI Foundations session.\n\n` +
        `My experience level:\nWhat I want to work on:\nTimes that work for me:\n\nThanks!`;
    return `mailto:${EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

export default function Book() {
    const [selected, setSelected] = useState(60);
    const session = SESSIONS.find((s) => s.minutes === selected);

    return (
        <div className="book-container">
            <div className="book-header">
                <p className="book-kicker">1:1 with Marc</p>
                <h1 className="book-title">AI Foundations</h1>
                <p className="book-sub">
                    Live 1:1, screen to screen. Beginner to intermediate &mdash; no AI
                    experience needed.
                </p>
            </div>

            <div className="book-options">
                {SESSIONS.map((s) => (
                    <button
                        key={s.minutes}
                        className={`book-option ${selected === s.minutes ? "active" : ""}`}
                        onClick={() => setSelected(s.minutes)}
                    >
                        <span className="book-option-time">{s.minutes} min</span>
                        <span className="book-option-price">${s.price}</span>
                        <span className="book-option-tag">{s.tagline}</span>
                    </button>
                ))}
            </div>

            <div className="book-actions">
                <a
                    className="book-cta"
                    href={bookingHref(session.minutes)}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <span className="book-step-num">1</span>
                    Pick a slot
                </a>
                <a
                    className="book-venmo"
                    href={venmoLink(session.minutes, session.price)}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <span className="book-step-num">2</span>
                    Venmo ${session.price}
                </a>
            </div>

            <p className="book-blurb">{session.blurb}</p>

            <p className="book-confirm">
                Put your name and booked time in the Venmo note &mdash; your slot is
                confirmed once payment lands, and the meeting link comes from{" "}
                <a href={`mailto:${EMAIL}`}>{EMAIL}</a>.
            </p>

            <p className="book-what">What we cover</p>
            <ul className="book-list">
                <li>Getting your AI coding setup working end to end</li>
                <li>Building your first real AI feature, not a toy demo</li>
                <li>Prompting, context, and which model to reach for</li>
                <li>Straight answers to whatever you're stuck on</li>
            </ul>

            <p className="book-fine">
                Need a different time or want to ask first? Email{" "}
                <a href={`mailto:${EMAIL}`}>{EMAIL}</a> &middot; Venmo @{VENMO_HANDLE}
            </p>
        </div>
    );
}
